
/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */

 let baseUrl = 'http://localhost:8080'; 
 // let baseUrl = 'http://203.76.212.73:7001'; 
 let routerMode = 'hash';
 let imgBaseUrl = '';
 let apiUrl = '';
 let reqUrl = 'https://api.applet.bxcmercury.com'
 
 if (process.env.NODE_ENV == 'development') {
	 // baseUrl = 'http://localhost:8000';
	 // baseUrl = 'http://localhost:7001';
	//  baseUrl = 'https://console.test.bxcmercury.com';
	 imgBaseUrl = '/img/';
 }else if(process.env.NODE_ENV == 'production'){
	 // apiUrl = 'http://203.76.212.73:7001'; 
	 baseUrl = 'https://console.bxcmercury.com';
	 imgBaseUrl = '';
 } 
 
 export {
	 baseUrl,
	 routerMode,
	 imgBaseUrl,
	 reqUrl
 }
 
